import { z } from 'zod'
import type { Brand } from './brand.ts'

/**
 * Identifiers are opaque strings. They are generated by an adapter (the Random
 * port), never by the domain, so that replaying an event log is deterministic.
 */

export type FamilyId = Brand<string, 'FamilyId'>
export type MemberId = Brand<string, 'MemberId'>
export type TaskId = Brand<string, 'TaskId'>
export type StepId = Brand<string, 'StepId'>
export type RewardId = Brand<string, 'RewardId'>
export type PurchaseId = Brand<string, 'PurchaseId'>
export type PhotoId = Brand<string, 'PhotoId'>
export type BadgeId = Brand<string, 'BadgeId'>
export type EventId = Brand<string, 'EventId'>
export type DeviceId = Brand<string, 'DeviceId'>
/** Supplied by the caller so that the same command applied twice is one event. */
export type CommandId = Brand<string, 'CommandId'>

const identifier = z.string().trim().min(1).max(64)

export const FamilyIdSchema = identifier as unknown as z.ZodType<FamilyId>
export const MemberIdSchema = identifier as unknown as z.ZodType<MemberId>
export const TaskIdSchema = identifier as unknown as z.ZodType<TaskId>
export const StepIdSchema = identifier as unknown as z.ZodType<StepId>
export const RewardIdSchema = identifier as unknown as z.ZodType<RewardId>
export const PurchaseIdSchema = identifier as unknown as z.ZodType<PurchaseId>
export const PhotoIdSchema = identifier as unknown as z.ZodType<PhotoId>
export const BadgeIdSchema = identifier as unknown as z.ZodType<BadgeId>
export const EventIdSchema = identifier as unknown as z.ZodType<EventId>
export const DeviceIdSchema = identifier as unknown as z.ZodType<DeviceId>
export const CommandIdSchema = identifier as unknown as z.ZodType<CommandId>
